import React, { FC } from 'react';
import { classes, style } from 'typestyle';
import { windowBackdropStyle } from '@traceair/tds';
import { useAppStore } from '../store/appStore';

type WindowManagerProps = {
  className?: string;
};

const WindowManager: FC<WindowManagerProps> = ({ className: windowClassName }) => {
  const window = useAppStore((state) => state.window);

  return window ? (
    <div className={classes(dialogStyle)}>
      <div className={classes('modal-backdrop', backdropStyle, windowBackdropStyle)} />
      <div className={classes('window-container', windowContainerStyle, windowClassName)}>{window}</div>
    </div>
  ) : null;
};

const dialogStyle = style({
  position: 'fixed',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: 400000,
  pointerEvents: 'none',
});

const backdropStyle = style({
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  zIndex: 400000,
  pointerEvents: 'all',
});

const windowContainerStyle = style({
  position: 'relative',
  width: 'auto',
  minWidth: 300,
  zIndex: 400000,
  pointerEvents: 'all',
  display: 'flex',
  justifyContent: 'center',
  maxHeight: '100%',
  $nest: {
    '& > div.tds-window': {
      width: '244px !important',
      minWidth: 'auto !important',
    },
  },
});

export default WindowManager;
